import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Dashboard from "./Dashboard";
import { getUserLocalData } from "../lib/helper";
import { generateCodeChallenge, generateCodeVerifier, generateRandomState } from "../lib/helper";

const QRLogin = () => {
  const [authUrl, setAuthUrl] = useState("");
   const [state, setState] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
  // const params1=useSearchParams();
  // const scopes = process.env.REACT_APP_SPECIFIC_SCOPES.split(" ");
  // const scopeParam = scopes.map(encodeURIComponent).join("%20");  
  const scopes = process.env.REACT_APP_SPECIFIC_SCOPES;
  const scopeParam = scopes; 
  useEffect(() => {
      localStorage.setItem("ref", 'qr');
      const initAuthProcess = async () => {
        const verifier = generateCodeVerifier();
        const newState = generateRandomState();
      localStorage.setItem("verifier", verifier);
      localStorage.setItem("state", state);
       
       const launch = searchParams.get("launch");
       const challenge = await generateCodeChallenge(verifier);
       const params = new URLSearchParams({
          client_id: process.env.REACT_APP_CLIENT_ID,
          aud: process.env.REACT_APP_MELDRX_WS_URL,
          redirect_uri: process.env.REACT_APP_REDIRECT_URI,
          scope: scopeParam,
          response_type: "code",
           state: newState,
          code_challenge: challenge,
          code_challenge_method: "S256",
        })
        
        if(launch){
         params.append('launch',launch)
        }
        
        // const authLink = `${process.env.REACT_APP_MELDRX_BASE_URL}connect/authorize?${params.toString()}`;
        const authLink = `${
        process.env.REACT_APP_EPIC_AUTH_URL
      }?${params.toString()}`;
        setAuthUrl(authLink);
        window.location.href = authLink; 
        // Redirect after setting state
      };
 
      initAuthProcess();
    }, []);

  return null
};

export default QRLogin;
